import { Box, LightBulbIcon, Typography } from '@customink/pigment-react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';

const InfoPill = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderRadius: '999px',
  background: '#FEEAE3',
  p: '0.125rem 0.3125rem',
  gap: '0.125rem',
  alignItems: 'center',
  width: 'fit-content',
  flexShrink: 0,
  color: theme.palette.red.main,
  padding: '0.125rem 0.375rem',
}));

export const GroupItemFittedProductTip = () => {
  return (
    <InfoPill data-testid="info-pill">
      <LightBulbIcon data-testid="lightbulb-icon" sx={{ fontSize: '1rem' }} />
      <Typography variant="uiTextTiny">
        Sizing Tip: This style runs small
      </Typography>
    </InfoPill>
  );
};
